// @flow

export default {
  isActive: {
    "ui:widget": "toggle",
  },
  standardQuestion: {
    id: {
      "ui:widget": "hidden",
    },
  },
  advisorType: {
    "ui:widget": "hidden",
  },
};
